import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import styled from '@xstyled/styled-components';
import { AudioPlayerV2, getColor, getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAudioWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var StyledAudioLabel = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n"])), getSize('padding8'), getColor('contentBody'), getSize('typo14'));
export var getAudioUrl = function getAudioUrl(audioFile) {
  if (!audioFile) return undefined;
  if (typeof audioFile === 'string' && audioFile.trim().length > 0) return audioFile;

  if (typeof audioFile === 'object' && audioFile !== null) {
    var candidate = audioFile.url;

    if (typeof candidate === 'string' && candidate.trim().length > 0) {
      return candidate;
    }
  }

  return undefined;
};
export var QuestionAudioComponent = function QuestionAudioComponent(_ref) {
  var audioFile = _ref.audioFile,
      questionId = _ref.questionId,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Audio' : _ref$label,
      audioPlayerLabels = _ref.audioPlayerLabels,
      _ref$disableAudioRule = _ref.disableAudioRules,
      disableAudioRules = _ref$disableAudioRule === void 0 ? true : _ref$disableAudioRule,
      _ref$isCanSeek = _ref.isCanSeek,
      isCanSeek = _ref$isCanSeek === void 0 ? true : _ref$isCanSeek,
      _ref$allowMultipleAud = _ref.allowMultipleAudiosPlay,
      allowMultipleAudiosPlay = _ref$allowMultipleAud === void 0 ? true : _ref$allowMultipleAud,
      audioPlayerConfig = _ref.audioPlayerConfig;
  var audioSource = getAudioUrl(audioFile);
  var effectiveConfig = useMemo(function () {
    var baseConfig = {
      isAllowedToReplay: true,
      isAllowedToPause: true,
      numberOfReplays: -1,
      isCanSeek: isCanSeek,
      allowMultipleAudiosPlay: allowMultipleAudiosPlay
    };
    return _objectSpread(_objectSpread({}, baseConfig), audioPlayerConfig);
  }, [isCanSeek, allowMultipleAudiosPlay, audioPlayerConfig]);

  if (!audioSource) {
    return null;
  }

  var normalizedQuestionId = typeof questionId === 'string' ? questionId : (questionId === null || questionId === void 0 ? void 0 : questionId.toString()) || '';
  return /*#__PURE__*/_jsxs(StyledAudioWrapper, {
    children: [label && /*#__PURE__*/_jsx(StyledAudioLabel, {
      children: label
    }), /*#__PURE__*/_jsx(AudioPlayerV2, {
      source: audioSource,
      audioId: "question-".concat(normalizedQuestionId),
      disableAudioRules: disableAudioRules,
      isCanSeek: isCanSeek,
      allowMultipleAudiosPlay: allowMultipleAudiosPlay,
      audioPlayerConfig: effectiveConfig,
      labels: audioPlayerLabels
    })]
  });
};